import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalsService } from './globals';
import { Observable } from 'rxjs';

@Injectable()
export class NoConformidad {


    constructor(private http: HttpClient, private globals: GlobalsService) {

    }

    listNoConformidad() {
        return this.http.get(`${this.globals.apiUrl}/api/gnc/registro`);
    }

    noConformidadId(id) {
        return this.http.get(`${this.globals.apiUrl}/api/gnc/${id}`);
    }

    tratamiento() {
        return this.http.get(`${this.globals.apiUrl}/api/gnc/tipo-tratamiento`);
    }

    clasificacion() {
        return this.http.get(`${this.globals.apiUrl}/api/gnc/clasificacion`);
    }

    userOrganizacion(): Observable<any> {
        return this.http.get(`${this.globals.apiUrl}/api/organizacion/usuario`);
    }

    registerNoConformidad(data) {
        return this.http.post(`${this.globals.apiUrl}/api/gnc`, data);
    }

    updateNoConformidad(id, data) {
        return this.http.put(`${this.globals.apiUrl}/api/gnc/${id}`, data);
    }

    deleteNoConformidad(id) {
        return this.http.delete(`${this.globals.apiUrl}/api/gnc/${id}`);
    }

    trashNoConformidad(data) {
        return this.http.post(`${this.globals.apiUrl}/api/gnc/trash`, data);
    }

    listNorma() {
        return this.http.get(`${this.globals.apiUrl}/api/organizacion/modulos`);
    }

    listProceso() {
        return this.http.get(`${this.globals.apiUrl}/api/proceso`);
    }

    evaluarId(id) {
        return this.http.put(`${this.globals.apiUrl}/api/gnc/${id}/evaluar`, null);
    }

    observaciones(id, data) {
        return this.http.post(`${this.globals.apiUrl}/api/gnc/${id}/no-apertura`, data);
    }

    apertura(id, data) {
        return this.http.post(`${this.globals.apiUrl}/api/gnc/${id}/apertura`, data);
    }

    listValidacion() {
        return this.http.get(`${this.globals.apiUrl}/api/gnc/validacion`);
    }

    remitirAprobador(id, data) {
        return this.http.put(`${this.globals.apiUrl}/api/gnc/${id}/remitir`, data);
    }

    listRequisito(moduloId, versionId) {
        return this.http.get(`${this.globals.apiUrl}/api/modulo/${moduloId}/version/${versionId}/requisito`);
    }
}
